import script from "./FilesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilesList.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__